import React from 'react';
import Radium from 'radium';
import PropTypes from 'prop-types';
import stylePropType from 'react-style-proptype';
import { MdPerson as PersonIcon } from 'react-icons/md';
import { mobile } from 'helpers/deviceCutoffs';
import { primaryRed, lightRed } from 'helpers/colors';

const ProfileIcon = ({
  profilePic = null,
  size = 30,
  style = {},
  dataTestId = ''
}) => {
  const accountBtnStyle = styles.accountBtn;
  accountBtnStyle.width = `${size}px`;
  accountBtnStyle.minWidth = `${size}px`;
  accountBtnStyle.height = `${size}px`;
  accountBtnStyle.borderRadius = `${size / 2}px`;
  accountBtnStyle.backgroundImage = 'none';
  if (profilePic) accountBtnStyle.backgroundImage = `url('${profilePic}')`;
  return (
    <div data-testid={dataTestId} style={{ ...accountBtnStyle, ...style }}>
      {!profilePic && <PersonIcon style={styles.accountIcon} />}
    </div>
  );
};

const styles = {
  accountBtn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: primaryRed,
    backgroundSize: 'contain',
    fontSize: '1.4em',
    [`@media (maxWidth: ${mobile}px)`]: {
      width: '23px',
      minWidth: '23px',
      height: '23px',
      fontSize: '.9em'
    }
  },
  accountIcon: {
    color: lightRed
  }
};

ProfileIcon.propTypes = {
  profilePic: PropTypes.string,
  size: PropTypes.number,
  style: stylePropType,
  dataTestId: PropTypes.string
};

export default Radium(ProfileIcon);
